module.exports = __webpack_public_path__ + "img/mission-gfp-cocoa.png?ddbc3914f99674a0930dc502d7ede109";